module.exports = __webpack_public_path__ + "img/Reflective_practice.776f0916.png";